import React, { Component } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
import ReactDOM from 'react-dom';

let defaultState = { show: false, disable: false };

class MyLoader extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { ...defaultState };
  }
  start() {
    this.setState({
      show: true,
    });
  }
  done() {
    this.setState({
      show: false,
    });
  }
  disable() {
    // show=falseの場合にdisplay=noneにしても良さそうだが全画面に影響あるので非表示のメソッドを用意
    this.setState({
      show: false,
      disable: true,
    });
  }
  render() {
    return (
      <LoadingOverlay
        active={this.state.show}
        styles={{
          wrapper: {
            width: '400px',
            height: '400px',
            overflow: this.state.show ? 'hidden' : 'scroll',
            display: this.state.disable ? 'none' : 'block',
          },
          overlay: base => ({
            ...base,
            background: 'rgba(0, 0, 0, 0.3)',
          }),
        }}
        spinner={<FadeLoader size={100} />}
      />
    );
  }
}
let div = document.createElement('div');
document.body.appendChild(div);

// eslint-disable-next-line react/no-render-return-value
let Loader = ReactDOM.render(React.createElement(MyLoader), div);
export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.jsx